import Vue from 'vue'
import App from './App.vue'
// import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import './styles/main.scss';
import { FORGEROCK_ENABLED } from './featureToggles';

Vue.config.productionTip = false;

// the ForgeRock SDK loads these redirect paths in a hidden iframe; any app
// code running there re-enters the auth flow, so the app is not mounted on
// them. Without ForgeRock there is no iframe, so mount as normal
const oauthCallbackPaths = ['/purchase/newcars/callback', '/finance/get-tpr/callback'];
const isOauthCallback = FORGEROCK_ENABLED && oauthCallbackPaths.some(p => window.location.pathname.startsWith(p));

if (!isOauthCallback) {
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
}
